import { ActiveToast, ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';

import { NgToastService } from 'ng-angular-popup';
import { Notification } from 'src/app/core/models/core.models';
import { NotificationComponent } from 'src/app/core/components/notification/notification.component';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(
    private toast: NgToastService,
    private toastr: ToastrService,
  ) {}

  showSuccess(message: string, title?: string) {
    this.toast.success(message, title ?? 'SUCCESS');
  }

  showError(message: string, title?: string) {
    this.toast.danger(message, title ?? 'ERROR');
  }

  showInfo(message: string, title?: string) {
    this.toast.info(message, title ?? 'INFO');
  }

  showWarning(message: string, title?: string) {
    this.toast.warning(message, title ?? 'WARNING');
  }

  showCustomNotification(notification: Notification) {
    // Show the toast and get a reference to it
    const toastRef: ActiveToast<any> = this.toastr.show(
      '',
      'New Notification',
      {
        toastComponent: NotificationComponent,
        closeButton: true,
        enableHtml: true,
        timeOut: 3000,
        extendedTimeOut: 0,
        positionClass: 'toast-bottom-right',
      },
    );

    // 🔹 Get the component reference and manually set the payload
    if (toastRef.toastRef.componentInstance) {
      (toastRef.toastRef.componentInstance as any)['notification'] =
        notification;
      (toastRef.toastRef.componentInstance as any)['toastRef'] =
        toastRef.toastRef;
    }
  }
}
